/* globals $:false */
/* globals console:false */

(function () {
    'use strict';

    let menuActive = false;
    let scrollLocation = 0;
    let currentLocation = 0;


    window.addEventListener("scroll", function (event) {
        scrollLocation = this.scrollY;
    });

    $(document).ready(function () {
        let overlayContainer = $('#menu-mobile');

        $('#menu-open, #menu-open-compact').on('click', function (event) {
            event.preventDefault();

            currentLocation = scrollLocation;

            $('body').css('overflow', 'hidden');

            navOpen();
        });

        $('#menu-close').on('click', function (event) {
            event.preventDefault();

            $('body').css('overflow', 'auto');

            navClose();
        });
    });

    $(window).resize(function () {
        resize();
    });

    function navOpen() {
        // $('#menu-mobile').removeClass('hide').addClass('show').css({'opacity': 1});
        $('#menu-mobile').removeClass('hide').addClass('show').css({'opacity': 1});

        resize();
        // $('#menu-header-row, #menu-list-row').css({'opacity': 1 });
    }

    function navClose() {
        $('#menu-mobile').removeClass('show').addClass('hide').css({'opacity': 0});
        // $('#menu-header-row, #menu-list-row').css({'opacity': 0 });
    }

    function resize() {
        let heightWindow = $(window).height();
        //
        // let header = $('#menu-header-row');
        // let heightHeader = header.height();
        //
        // let menu = $('#menu-list-row');
        // let heightMenu = menu.height();
        //
        // let margin = (heightWindow - (heightHeader + heightMenu)) / 7;
        // let marginTop = margin * 3;
        //
        // let totalHeight = heightHeader + heightMenu + 50 + 50;
        //
        // if (totalHeight <= heightWindow) {
        //     menu.css('marginTop', marginTop + 'px');
        // } else {
        //
        // }
    }
}());

/* Compact navbar: hidden normally, slides in fixed to the top once the user
   scrolls past the main .navbar, and hides again when it scrolls back into view. */
(function () {
    'use strict';

    $(document).ready(function () {
        let $navbar = $('.navbar');
        let $compact = $('.navbar-compact');

        if (!$navbar.length || !$compact.length) {
            return;
        }

        // Pin the compact navbar to the top of the viewport, hidden until needed.
        $compact.css({
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1000
        }).addClass('hide');

        function updateCompactNav() {
            // Bottom edge of the main navbar. Once the page has scrolled past it,
            // the normal navbar is out of view, so reveal the compact one.
            let navbarBottom = $navbar.offset().top + $navbar.outerHeight();

            if (window.scrollY > navbarBottom) {
                $compact.removeClass('hide');
            } else {
                $compact.addClass('hide');
            }
        }

        window.addEventListener('scroll', updateCompactNav);
        updateCompactNav();
    });
}());